import { render, staticRenderFns } from "./MoissonCard.vue?vue&type=template&id=4702cc56"
import script from "./MoissonCard.vue?vue&type=script&lang=js"
export * from "./MoissonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports